export function createReducerAction<T extends string>(type: T): ReducerAction<T>;
export function createReducerAction<T extends string, P extends {}>(type: T, payload: P): ReducerActionWithPayload<T, P>;
export function createReducerAction<T extends string, P extends {}>(type: T, payload?: P): ReducerAction<T> | ReducerActionWithPayload<T, P> {
  return payload ? { type, payload } : { type };
}
